const app = require('app'),
    setCookie = require('./setCookie');

module.exports = function (language) {
    return setCookie('language', language, 365);
};
